export interface IToast {
  open: boolean;
  message: string;
  severity?: ToastSeverity;
  dismissTime?: number;
}

export enum ToastSeverity {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info'
}